export default {
  options: [{
      value: "fushineiyi",
      label: "服饰内衣",
      children: [{
          value: "nvzhuang",
          label: "女装",
          children: [{
              value: "chenshan",
              label: "衬衫"
            },
            {
              value: "maoyi",
              label: "毛衣"
            },
            {
              value: "yurongfu",
              label: "羽绒服"
            },
            {
              value: "fengyi",
              label: "风衣"
            },
            {
              value: "lianyiqun",
              label: "连衣裙"
            },
          ],
        },
        {
          value: "nanzhuang",
          label: "男装",
          children: [{
              value: "yangmaoshan",
              label: "羊毛衫"
            },
            {
              value: "jiake",
              label: "夹克"
            },
            {
              value: "maoyi",
              label: "毛衣"
            },
            {
              value: "yurongfu",
              label: "羽绒服"
            },
            {
              value: "fengyi",
              label: "风衣"
            },
          ],
        },
        {
          value: "meiyikuwa",
          label: "内衣裤袜",
          children: [{
              value: "shuiyi",
              label: "睡衣"
            },
            {
              value: "wazi",
              label: "袜子"
            },
            {
              value: "baonuanneiyi",
              label: "保暖内衣"
            },
          ],
        },
      ],
    },
    {
      value: "meizhuang",
      label: "美妆",
      children: [{
          value: "meironghufu",
          label: "美容护肤",
          children: [{
              value: "nanshihufu",
              label: "男士护肤"
            },
            {
              value: "fangshai",
              label: "防嗮"
            },
            {
              value: "yanbuhuli",
              label: "眼部护理"
            },
            {
              value: "chunbuhuli",
              label: "唇部护理"
            },
          ],
        },
        {
          value: "caizhuang",
          label: "彩妆/香水",
          children: [{
              value: "meizhuanggongju",
              label: "美妆工具",
              children: [{
                  value: "shuangyanpitie",
                  label: "双眼皮贴"
                },
                {
                  value: "huazhuangmian",
                  label: "化妆棉"
                },
                {
                  value: "jiajiemao",
                  label: "假睫毛"
                },
              ],
            },
            {
              value: "xiangshui",
              label: "香水/香膏"
            },
            {
              value: "zhijiayou",
              label: "指甲油"
            },
          ],
        },
        {
          value: "meirong",
          label: "美容/个护仪器",
          children: [{
              value: "nvshituomao",
              label: "女士脱毛/剃毛器"
            },
            {
              value: "dianzimeirongyi",
              label: "电子美容仪"
            },
          ],
        },
      ],
    },
    {
      value: "shipinyinliao",
      label: "食品饮料",
      children: [{
          value: "liangyoumimian",
          label: "粮油米面",
          children: [{
              value: "qingshijiancan",
              label: "轻食简餐"
            },
            {
              value: "tiaoweipin",
              label: "调味品",
              children: [{
                  value: "guojiang",
                  label: "果酱"
                },
                {
                  value: "doufuru",
                  label: "豆腐乳"
                },
                {
                  value: "shiyongtang",
                  label: "食用糖"
                },
                {
                  value: "tiaoweiliao",
                  label: "调味料"
                },
              ],
            },
            {
              value: "fangbiansushi",
              label: "方便速食",
              children: [{
                  value: "gauntou",
                  label: "罐头"
                },
                {
                  value: "jishihuoguo",
                  label: "即食火锅"
                },
                {
                  value: "fangbianmian",
                  label: "方便面"
                },
                {
                  value: "miantiao",
                  label: "面条/挂面"
                },
              ],
            },
          ],
        },
        {
          value: "lingshi",
          label: "零食",
          children: [{
              value: "qiaokeli",
              label: "巧克力"
            },
            {
              value: "gaodian",
              label: "糕点/点心"
            },
            {
              value: "rougan",
              label: "肉干/肉脯"
            },
            {
              value: "tangguolingshi",
              label: "糖果零食"
            },
          ],
        },
        {
          value: "yinliao",
          label: "饮料",
          children: [{
              value: "yinyongshui",
              label: "饮用水"
            },
            {
              value: "tansuanyinliao",
              label: "碳酸饮料"
            },
            {
              value: "chayinliao",
              label: "茶饮料"
            },
          ],
        },
        {
          value: "baojianshipin",
          label: "保健食品",
          children: [{
              value: "danbaifen",
              label: "蛋白粉"
            },
            {
              value: "zhiwujinghua",
              label: "植物精华"
            },
            {
              value: "shanshixianwei",
              label: "膳食纤维"
            },
          ],
        },
      ],
    },
    {
      value: "tushuyinxiang",
      label: "图书音像",
      children: [{
          value: "shuji",
          label: "书籍/杂志",
          children: [{
              value: "zhexue",
              label: "哲学宗教"
            },
            {
              value: "zhengzhijunshi",
              label: "政治军事"
            },
            {
              value: "jingji",
              label: "经济"
            },
            {
              value: "shenghuo",
              label: "生活"
            },
            {
              value: "xiaoshuo",
              label: "小说"
            },
          ],
        },
        {
          value: "xuexiyongpin",
          label: "学习用品",
          children: [{
              value: "huaju",
              label: "画具"
            },
            {
              value: "wenju",
              label: "文具"
            },
            {
              value: "jiaoxueyanshi",
              label: "教学演示"
            },
          ],
        },
        {
          value: "jiaoyuyingxiang",
          label: "教育影像",
          children: [{
              value: "dianying",
              label: "电影"
            },
            {
              value: "dianshiju",
              label: "电视剧"
            },
            {
              value: "xiqu",
              label: "戏曲综艺"
            },
          ],
        },
      ],
    },
    {
      value: "3C",
      label: "3C数码家电",
      children: [{
          value: "shouji",
          label: "手机",
          children: [{
              value: "gongnengji",
              label: "功能机"
            },
            {
              value: "zhinengji",
              label: "智能机"
            },
          ],
        },
        {
          value: "diannao",
          label: "电脑",
        },
        {
          value: "jiadian",
          label: "大家电",
          children: [{
              value: "kogntiao",
              label: "空调"
            },
            {
              value: "bingxiang",
              label: "冰箱"
            },
            {
              value: "xiyiji",
              label: "洗衣机"
            },
            {
              value: "dianshi",
              label: "电视"
            },
            {
              value: "reshuiqi",
              label: "热水器"
            },
          ],
        },
        {
          value: "bangongyongpin",
          label: "办公用品",
          children: [{
              value: "dayingji",
              label: "打印机"
            },
            {
              value: "bangongyongzhi",
              label: "办公用纸"
            },
            {
              value: "suizhiji",
              label: "碎纸机"
            },
          ],
        },
        {
          value: "dianwan",
          label: "电玩/配件",
          children: [{
              value: "PS",
              label: "PS主机专用"
            },
            {
              value: "SWITCH",
              label: "任天堂 SWITCH"
            },
            {
              value: "XBOX",
              label: "XBOX 专用"
            },
            {
              value: "youxiruanjian",
              label: "游戏软件"
            },
          ],
        },
      ],
    },
    {
      value: "shenghuofuwu",
      label: "生活服务",
      children: [{
          value: "hunqingjiaoyou",
          label: "婚庆交友",
          children: [{
              value: "lvpai",
              label: "旅拍"
            },
            {
              value: "bendipaishe",
              label: "本地拍摄"
            },
          ]
        },
        {
          value: "hunshasheying",
          label: "婚纱摄影"
        },
        {
          value: "sheyingxiezhen",
          label: "摄影写真",
          children: [{
              value: "gerenxiezhen",
              label: "个人写真"
            },
            {
              value: "quanjiafu",
              label: "全家福"
            },
            {
              value: "zhengjianzhao",
              label: "证件照"
            },
            {
              value: "ertongzhao",
              label: "儿童照"
            },
            {
              value: "qinzizhao",
              label: "亲子照"
            },
          ],
        },
        {
          value: "sheying",
          label: "摄影",
          children: [{
            value: "sheying",
            label: "儿童摄影"
          }]
        }
      ],
    },
    {
      value: "chongwushenghuo",
      label: "宠物生活",
      children: [{
          value: "chongwuzhuliang",
          label: "宠物主粮",
          children: [{
              value: "maoliang",
              label: "猫粮"
            },
            {
              value: "gouliang",
              label: "狗粮"
            },
          ]
        },
        {
          value: "yiliaobaojian",
          label: "医疗保健",
          children: [{
              value: "naifen",
              label: "奶粉"
            },
            {
              value: "fayubugai",
              label: "发育补钙"
            },
            {
              value: "chongwuquchong",
              label: "宠物驱虫"
            },
            {
              value: "pifubingfangzhi",
              label: "皮肤病防治"
            },
          ]
        },
        {
          value: "chongwujiaju",
          label: "宠物家具",
          children: [{
            value: "yugang",
            label: "鱼缸"
          }]
        },
        {
          value: "maogouwanju",
          label: "猫狗玩具",
          children: [{
              value: "maowanju",
              label: "猫玩具"
            },
            {
              value: "pajia",
              label: "猫爬架/猫抓板"
            },
            {
              value: "gouwanju",
              label: "狗玩具"
            },
          ]
        },
        {
          value: "chuxingzhuangbei",
          label: "出行装备",
          children: [{
              value: "chongwuqianyin",
              label: "宠物牵引"
            },
            {
              value: "bianxiebao",
              label: "便携包/笼"
            },
          ]
        },
      ],
    },
    {
      value: "yingyongruanjian",
      label: "应用软件",
      children: [{
          value: "shejiao",
          label: "社交",
          children: [{
              value: "liaotianjiaoyou",
              label: "聊天交友"
            },
            {
              value: "hunlian",
              label: "婚恋"
            },
          ]
        },
        {
          value: "yingyinbofang",
          label: "影音播放",
          children: [{
              value: "shipin",
              label: "视频"
            },
            {
              value: "yinyue",
              label: "音乐"
            },
          ]
        },
        {
          value: "zixunyuedu",
          label: "资讯阅读",
          children: [{
              value: "xinwenzixun",
              label: "新闻资讯"
            },
            {
              value: "dianzishu",
              label: "电子书"
            },
            {
              value: "gaoxiao",
              label: "搞笑"
            },
            {
              value: "manhua",
              label: "漫画"
            },
          ]
        },
        {
          value: "sheyingtuxiang",
          label: "摄影图像",
          children: [{
              value: "tuxiangbianji",
              label: "图像编辑"
            },
            {
              value: "xiangji",
              label: "相机"
            },
          ]
        },
        {
          value: "kaoshixuexi",
          label: "考试学习",
          children: [{
              value: "xuexigongju",
              label: "学习工具"
            },
            {
              value: "kaoshizhunbei",
              label: "考试准备"
            },
            {
              value: "waiguoyuxuexi",
              label: "外国语学习",
              children: [{
                  value: "riyu",
                  label: "日语学习"
                },
                {
                  value: "hanyu",
                  label: "韩语学习"
                },
                {
                  value: "yingyu",
                  label: "英语学习"
                },
              ]
            },
            {
              value: "zidian",
              label: "字典与翻译工具"
            },
          ]
        },
        {
          value: "wanggoupingtai",
          label: "网购平台",
          children: [{
              value: "dianshangpingtai",
              label: "电商平台"
            },
            {
              value: "tuangou",
              label: "团购/优惠"
            },
            {
              value: "haitaodaogou",
              label: "海淘导购"
            },
            {
              value: "kuaidi",
              label: "快递"
            },
          ]
        },
        {
          value: "jiankangyundong",
          label: "健康运动",
          children: [{
              value: "jianfeijianshen",
              label: "减肥健身"
            },
            {
              value: "yiliao",
              label: "医疗"
            },
            {
              value: "yangsheng",
              label: "养生"
            },
            {
              value: "huaiyun",
              label: "怀孕"
            },
            {
              value: "jingqi",
              label: "经期"
            },
          ]
        },
        {
          value: "yuerqinzi",
          label: "育儿亲子",
          children: [{
              value: "yuerzaojiao",
              label: "育儿早教"
            },
            {
              value: "jianggushi",
              label: "讲故事"
            },
            {
              value: "changerge",
              label: "唱儿歌"
            },
            {
              value: "xiaoerbaike",
              label: "小儿百科"
            },
          ]
        },
      ]
    },
  ],
}